export enum BadgeType {
  DEFAULT = 'default',
  CAPSULE = 'capsule',
}

export enum TeaserType {
  SIMPLE = 'simple',
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  LANDSCAPE = 'landscape',
  LANDSCAPE_FULL_GRID = 'landscape-full-grid',
  STAGE = 'stage',
  HUB = 'hub',
  TOOLS = 'tools',
}

export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  TERTIARY_ICON = 'tertiary-icon',
  PRIMARY_ICON = 'primary-icon',
  SECONDARY_ICON = 'secondary-icon',
  DOUBLE_ICON = 'double-icon',
  BACK_TO_TOP = 'back-to-top',
  SQUARED_PRIMARY = 'squared-primary',
  SQUARED_SECONDARY = 'squared-secondary',
  ROUNDED_PRIMARY = 'rounded-primary-reduced',
  ROUNDED_SECONDARY = 'rounded-secondary-reduced',
  ROUNDED_TERTIARY = 'rounded-tertiary-reduced',
  SEARCH = 'search',
  SEARCH_NO_BG = 'squared-primary-no-bg',
  LOGIN = 'login',
  MENU = 'menu',
  DROPDOWN = 'dropdown',
  EXIT = 'exit',
  OPEN_CLOSE = 'openclose',
  OPEN_CLOSE_SECONDARY = 'openclose-secondary',
  CHILDREN = 'children',
}

export enum LinkType {
  DEFAULT = 'default',
  PRIMARY_ARROW = 'primary-arrow',
  PRIMARY_ICON = 'primary-icon',
  SECONDARY_ICON = 'secondary-icon',
  SECONDARY_ICON_LIGHT = 'secondary-icon-light',
  INLINE = 'inline',
  DOWNLOAD = 'download',
  DOWNLOAD_NO_UNDERSCORED = 'download-no-underscored',
  EXTERNAL = 'external',
  SECONDARY_EXTERNAL = 'secondary-external',
  SECONDARY_EXTERNAL_NO_UNDERSCORE = 'secondary-external-no-underscored',
  BREADCRUMB = 'Breadcrumb',
  BREADCRUMB_NO_ICON = 'Breadcrumb-no-icon',
  VIDEO_LINK = 'video-link',
  VIDEO_LINK_NO_UNDERSCORE = 'video-link-no-underscore',
  VIDEO_LINK_LIGHT = 'video-link-light',
  MEDIA_LINK = 'media-link',
  MEDIA_LINK_LIGHT = 'media-link-light',
  FLYER_LINK = 'flyer-link',
  NAVBAR_MAIN_LINK = 'navbar-main-link',
  NAVBAR_MAIN_LINK_ACTIVE = 'navbar-main-link-active',
}

export enum HrefType {
  ANGULAR_ROUTE = 'angularRoute',
  OPEN_FLYOUT = 'openFlyout',
  EXTERNAL = 'externalLink',
  INTERNAL = 'internalLink',
  OPEN_MODAL_VIDEO = 'openModalVideo',
}

export enum Sizes {
  XSMALL = 'xsmall',
  SMALL = 'small',
  XMEDIUM = 'xmedium',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
  XXXLARGE = 'xxxlarge',
}

export enum Colors {
  WHITE = '#fff',
  BLACK = '#000',
  BLACK_LIGHT = '#3b3c3c',
  GREEN = '#65a518',
  GREEN_LIGHT = '#c1dba3',
  GREEN_SUCCESS = '#e0edd1',
  GREEN_LOGO = '#006729',
  TURQUOISE = '#008080',
  BLUE = '#003960',
  LIGHT_BLUE = '#00a3a8',
  NEUTRAL_DARK = '#282828',
  NEUTRAL_MEDIUM = '#6c6f70',
  NEUTRAL_LIGHTEST = '#f9f9fa',
  NEUTRAL_LIGHTER = '#eeeeef',
  GREY = '#6C6F70',
  LILLA = '#E20AD1',
  ERROR = '#E60018',
}

export enum Headlines {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}
